import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { useCart } from "../../context/cart";
import {} from "react-router-dom";

import "../../css/CategoryPage.css";
import axios from "axios";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import DropIn from "braintree-web-drop-in-react";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";

const Checkout = () => {
  const [clientToken, setClientToken] = useState("");
  const [instance, setInstance] = useState("");
  const [auth] = useAuth();
  const { cart, clearCart, getCartTotal, decrementItem, getCartTT } = useCart();
  const [showModal, setShowModal] = useState(false);
  const totalAmount = getCartTT();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  // Guest checkout form state
  const [guestInfo, setGuestInfo] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    address: {
      street1: "",
      street2: "",
      city: "",
      state: "",
      zip: "",
    },
  });

  const navigate = useNavigate();
  const location = useLocation();
  const userId = auth?.currentUser?.id;
  const isLoggedIn = !!auth.token;
  const apiUrl = `${process.env.REACT_APP_API}`;

  const freeShippingThreshold = 50.00;
  const baseShipping = 7;
  // Free shipping for orders over $50
  const ship = getCartTT() >= freeShippingThreshold ? 0 : (getCartTT() > 0 ? baseShipping : 0);

  const handleGuestInfoChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith("address.")) {
      const addressField = name.split(".")[1];
      setGuestInfo((prev) => ({
        ...prev,
        address: {
          ...prev.address,
          [addressField]: value,
        },
      }));
    } else {
      setGuestInfo((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validateGuestInfo = () => {
    const { email, firstName, lastName, phone, address } = guestInfo;
    if (!email || !firstName || !lastName || !phone) {
      toast.error("Please fill in all required fields");
      return false;
    }
    if (!address.street1 || !address.city || !address.state || !address.zip) {
      toast.error("Please fill in complete shipping address");
      return false;
    }
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return false;
    }
    return true;
  };

  const handleBuy = async (req, res) => {
    try {
      const insufficientItems = [];
      for (let i = 0; i < cart.length; i++) {
        const response = await fetch(`${apiUrl}/product/${cart[i].product}`);
        const data = await response.json();

        const chosenSize = data.productSize.sizes.find(
          (sizeObj) => sizeObj.label === cart[i].selectedSize
        );

        const presentQty = chosenSize.quantity;

        if (presentQty < cart[i].quantity) {
          insufficientItems.push(data.productName);
          decrementItem(data, cart[i].selectedSize);
        }
      }

      if (insufficientItems.length > 0) {
        // Alert user of out-of-stock items and do not proceed with transaction
        const message = ` The following items are out of stock: ${insufficientItems.join(
          ", "
        )}. \n We have removed these items from your cart.`;
        toast.error(message, { duration: 10000 });
        navigate("/cart");

        return;
      }

      console.log(totalAmount);
      await axios
        .post("/stripe-checkout", {
          userId,
          totalAmount,
          ship,
          cart,
        })
        .then((res) => res.data)
        .then((url) => {
          window.location.href = url;
        })
        .catch((err) => {
          console.log(err);
          toast.error(
            err.response?.data?.error ||
              "Error processing checkout. Please try again."
          );
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handleGuestBuy = async () => {
    try {
      if (!validateGuestInfo()) {
        return;
      }

      const insufficientItems = [];
      for (let i = 0; i < cart.length; i++) {
        const response = await fetch(`${apiUrl}/product/${cart[i].product}`);
        const data = await response.json();

        const chosenSize = data.productSize.sizes.find(
          (sizeObj) => sizeObj.label === cart[i].selectedSize
        );

        const presentQty = chosenSize.quantity;

        if (presentQty < cart[i].quantity) {
          insufficientItems.push(data.productName);
          decrementItem(data, cart[i].selectedSize);
        }
      }

      if (insufficientItems.length > 0) {
        const message = ` The following items are out of stock: ${insufficientItems.join(
          ", "
        )}. \n We have removed these items from your cart.`;
        toast.error(message, { duration: 10000 });
        navigate("/cart");
        return;
      }

      const { data } = await axios.post(`${apiUrl}/stripe-checkout-guest`, {
        cart,
        ship,
        guestInfo,
      });

      // Store guest info and session ID in localStorage
      localStorage.setItem("guestCheckout", JSON.stringify({
        guestInfo,
        sessionId: data.sessionId,
      }));

      window.location.href = data.url;
    } catch (err) {
      console.error(err);
      toast.error(
        err.response?.data?.error ||
          "Error processing checkout. Please try again."
      );
    }
  };

  const count = getCartTotal();

  if (count === 0) {
    navigate(location.state || "/", { replace: true });
    return null;
  }

  return (
    <>
      <Header />
      <div className="container mb-5">
        <h1
          className="mt-4 text-center"
          style={{ color: "#002E6A", fontWeight: "400" }}
        >
          {isLoggedIn ? "Confirm Address" : "Guest Checkout"}
        </h1>
        <hr />

        {isLoggedIn ? (
          // Logged-in user checkout
          <div className="container d-flex justify-content-center">
            <div className="col-md-6 d-flex justify-content-center">
              <div className="mt-5 mb-2">
                <h2
                  style={{ color: "#C70044", fontWeight: "300" }}
                  className="ml-3"
                >
                  Delivery Address:
                </h2>
                <h5>
                  {auth.currentUser.address.street1},{" "}
                  {auth.currentUser.address.street2}
                </h5>
                <h5>
                  {auth.currentUser.address.city},
                  {auth.currentUser.address.state},
                  {auth.currentUser.address.zip}
                </h5>
                <div className="d-flex justify-content-center mt-4 mb-3">
                  <button
                    className="btn btn-link"
                    style={{ color: "blue" }}
                    onClick={() =>
                      navigate("/profile", {
                        state: "/cart/checkout",
                      })
                    }
                  >
                    Change Address
                  </button>
                </div>

                <div className="d-flex justify-content-center mt-4 mb-3">
                  <button
                    onClick={handleBuy}
                    className="btn btn-success w-100 mt-8"
                    style={{ color: "white" }}
                  >
                    Proceed To Payment
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // Guest checkout form
          <div className="container d-flex justify-content-center">
            <div className="col-md-8">
              <div className="card shadow-sm p-4 mt-4">
                <h4 className="mb-4" style={{ color: "#C70044" }}>
                  Shipping Information
                </h4>
                <p className="text-muted mb-4">
                  After completing your order, you'll have the option to create an account.
                </p>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">First Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="firstName"
                      value={guestInfo.firstName}
                      onChange={handleGuestInfoChange}
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Last Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lastName"
                      value={guestInfo.lastName}
                      onChange={handleGuestInfoChange}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Email *</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={guestInfo.email}
                    onChange={handleGuestInfoChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Phone *</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    value={guestInfo.phone}
                    onChange={handleGuestInfoChange}
                    required
                  />
                </div>

                <h5 className="mt-4 mb-3" style={{ color: "#C70044" }}>
                  Shipping Address
                </h5>

                <div className="mb-3">
                  <label className="form-label">Street Address *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address.street1"
                    value={guestInfo.address.street1}
                    onChange={handleGuestInfoChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Apartment, Suite, etc. (Optional)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address.street2"
                    value={guestInfo.address.street2}
                    onChange={handleGuestInfoChange}
                  />
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">City *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="address.city"
                      value={guestInfo.address.city}
                      onChange={handleGuestInfoChange}
                      required
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">State *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="address.state"
                      value={guestInfo.address.state}
                      onChange={handleGuestInfoChange}
                      maxLength="2"
                      placeholder="CA"
                      required
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">ZIP Code *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="address.zip"
                      value={guestInfo.address.zip}
                      onChange={handleGuestInfoChange}
                      required
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <button
                    onClick={handleGuestBuy}
                    className="btn btn-success w-100"
                    style={{ padding: "12px" }}
                  >
                    Proceed To Payment
                  </button>
                </div>

                <div className="mt-3 text-center">
                  <p className="text-muted">
                    Already have an account?{" "}
                    <button
                      className="btn btn-link p-0"
                      onClick={() => navigate("/login", { state: "/cart/checkout" })}
                    >
                      Sign In
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Checkout;
